import { render, staticRenderFns } from "./articleDetails.vue?vue&type=template&id=1e27dfd6&scoped=true&"
import script from "./articleDetails.vue?vue&type=script&lang=js&"
export * from "./articleDetails.vue?vue&type=script&lang=js&"
import style0 from "./articleDetails.vue?vue&type=style&index=0&id=1e27dfd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e27dfd6",
  null
  
)

export default component.exports